import { NgModule } from '@angular/core';

import { StoryboardListRoutingModule } from './storyboard-list-routing.module';
import { StoryboardListComponent } from './storyboard-list.component';
import {CreateStoryboardComponent} from './create-storyboard/create-storyboard.component';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '../../shared/shared.module';
import {MediaLibraryModule} from '../../media-library/media-library.module';
import {StoryboardItemComponent} from './storyboard-item/storyboard-item.component';
import {PromptModalComponent} from "../../shared/prompt-modal/prompt-modal.component";

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    StoryboardListRoutingModule,
    MediaLibraryModule
  ],
  entryComponents: [CreateStoryboardComponent, PromptModalComponent],
  declarations: [StoryboardListComponent, CreateStoryboardComponent, StoryboardItemComponent],
})
export class StoryboardListModule {}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/storyboard-list.module.ts